<script lang="ts">
	import { menuBlockIn } from '$lib/animations/MenuTransitions';
	import type { GlobalSettingsType } from '$lib/queries/GlobalSettingsQuery';
	import CustomIcon from '@atoms/CustomIcon.svelte';
	import { ThinArrow } from '@icons';
	import Theme from '@tools/styles/Theme.svelte';

	let {
		data,
		index
	}: {
		data: GlobalSettingsType['menus'][0]['blocks'][0];
		index: number;
	} = $props();

	const theme = new Theme(data.colorTheme ? data.colorTheme : index * 2);
</script>

<a {...data.link} style={theme.css} in:menuBlockIn|global>
	<CustomIcon name={data.title} />
	<h3 class="text:h5">{data.title}</h3>
	<p>{data.description}</p>
	<div class="button:round">
		<ThinArrow />
	</div>
</a>

<style lang="scss">
	a {
		background-color: var(--theme-primary);
		color: var(--theme-foreground);
		display: flex;
		flex-direction: column;
		flex: 1 1 0;
		padding: $gap6;
		gap: $gap4;
		text-decoration: none;

		&:nth-child(1) {
			padding-left: var(--gutter);
		}

		&:nth-last-child(1) {
			padding-right: var(--gutter);
		}

		:global(> svg) {
			height: 3.2em;
			width: 3.2em;
			transition: transform $transition;
		}

		&:hover {
			:global(> svg) {
				height: 3.2em;
				width: 3.2em;
				transform: translateY(-#{$gap2});
			}
		}

		@include md {
			min-height: 30vh;
		}

		&:global(:not(:has(> svg)) p) {
			margin-bottom: calc(3.2em + $gap4);
		}
	}

	div {
		margin-top: auto;
		margin-left: auto;
	}
</style>
